module.exports = __webpack_public_path__ + "static/media/objects2_06.d96de43d.svg";